import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import MuiVirtualizedTable from "../../components/MuiVirtualizedTable";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import InputBase from "@material-ui/core/InputBase";
import SearchIcon from "@material-ui/icons/Search";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Tooltip from "@material-ui/core/Tooltip";

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(1)
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  },
  iconButton: {
    padding: 10
  },
  input: {
    marginLeft: 8,
    flex: 1
  }
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing.unit * 1
  }
}))(MuiDialogContent);

class Detalhe extends React.Component {
  constructor(props) {
    super(props);
    this.state = { itens: [] };
  }

  handleClose = () => {
    this.props.close();
  };

  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.itens !== this.props.itens || nextProps.open !== this.props.open
    );
  }

  render() {
    const { itens, open, dados, classes } = this.props;

    return (
      <Dialog
        fullScreen
        onClose={this.handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogContent>
          <Card>
            <CardHeader
              style={{ backgroundColor: "#efefef", padding: "9px" }}
              action={
                <div>
                  <InputBase
                    className={classes.input}
                    placeholder="Pesquisar veículo..."
                    inputProps={{ "aria-label": "Pesquisar veículo..." }}
                  />
                  <IconButton
                    className={classes.iconButton}
                    aria-label="Search"
                  >
                    <SearchIcon />
                  </IconButton>

                  <Tooltip title="Fechar">
                    <IconButton
                      className={classes.button}
                      onClick={this.handleClose}
                      aria-label="Fechar"
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              }
              title="Detalhamento"
            />

            <CardContent>
              <div style={{ height: "calc(100vh - 215px)", width: "100%" }}>
                <MuiVirtualizedTable
                  rowCount={itens.length}
                  rowGetter={({ index }) => itens[index]}
                  columns={[
                    {
                      width: 100,
                      label: "Seq.",
                      dataKey: "seq"
                    },
                    {
                      width: 500,
                      label: "Unidade",
                      dataKey: "Unidade"
                    },
                    {
                      width: 120,
                      label: "Veiculo",
                      dataKey: "Veiculo"
                    },
                    {
                      width: 420,
                      label: "Modelo",
                      dataKey: "Modelo"
                    },
                    {
                      width: 320,
                      label: "Municipio",
                      dataKey: "Municipio"
                    },
                    {
                      width: 120,
                      label: "Status",
                      dataKey: "Status"
                    },
                    {
                      width: 220,
                      label: "Dvec",
                      dataKey: "Dvec"
                    },
                    {
                      width: 120,
                      label: "ValorTransacao",
                      dataKey: "ValorTransacao",
                      numeric: true
                    }
                  ]}
                />
              </div>
              <Table size="small">
                <TableBody>
                  <TableRow>
                    <TableCell>Subtotal</TableCell>
                    <TableCell align="right">
                      {dados.NumeroDispositivos +
                        " x R$ " +
                        dados.ValorTransacao}
                    </TableCell>
                    <TableCell colSpan={4} align="right">
                      {dados.ValorServico}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>IMR</TableCell>
                    <TableCell colSpan={4} align="right">
                      {dados.FatuImr}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={4}>Total</TableCell>
                    <TableCell align="right">
                      {parseFloat(dados.ValorServico) *
                        parseFloat(dados.FatuImr)}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </CardContent>
          </Card>
        </DialogContent>
      </Dialog>
    );
  }
}

Detalhe.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Detalhe);
